var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((Object.entries(_vm.compositions)),function([key, value]){return _c('tr',{key:key},[_c('td',[_vm._v(_vm._s(key)+":")]),_c('td',[_c('Composition',{attrs:{"composition":value}})],1)])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }